import { Vista } from "@essenza/react";
import { useVista } from "@essenza/react";


export function NotificationVistaController(c) {
    c.skin = NotificationVista;
    let store = null;
    c.command = {
    }
}

export function NotificationVista(info) {
    const [ctx] = useVista(NotificationVistaController);
    return (
        <Vista context={ctx} >
            <div className="w100 py-md">
                <div className="centered max-width-sm text-center">
                  <h1>Nessuna notifica presente!</h1>
                </div>
            </div>
        </Vista>
    )
}